// START_MODULE pages_main_sections_gallery_gallery_tsx
// START_CONTRACT
// PURPOSE: Present a curated photographic archive of Tomsk Data Science meetings.
// OPERATIONAL_CONTEXT: The gallery is rendered on the main page from local photographs selected from the public Telegram channel.
// CONTRACT: Show only community-event photographs, keep manual navigation and render slides without transition animation.
// KEYWORDS: gallery, telegram-archive, community-events, static-site
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { GalleryImage } from './styled';

import Meeting202602 from 'assets/telegram/195-1.jpg';
import Meeting202503 from 'assets/telegram/171-1.jpg';
import Meeting202412 from 'assets/telegram/167-1.jpg';
import Meeting202409 from 'assets/telegram/154-1.jpg';
import Meeting20240727 from 'assets/telegram/150-1.jpg';
import Meeting202407A from 'assets/telegram/139-1.jpg';
import Meeting202407B from 'assets/telegram/139-2.jpg';
import TinkoffMeetingA from 'assets/telegram/125-1.jpg';
import TinkoffMeetingB from 'assets/telegram/125-3.jpg';
import GeoDataScienceA from 'assets/telegram/119-1.jpg';
import GeoDataScienceB from 'assets/telegram/119-2.jpg';
import TextAnalyticsMeeting from 'assets/telegram/109-1.jpg';
import DataFestBreakfast from 'assets/telegram/106-2.jpg';
import FirstMeetup from 'assets/telegram/92-1.jpg';
import AutumnMeeting from 'assets/telegram/90-1.jpg';
import ReinforcementLearningMeeting from 'assets/telegram/41-2.jpg';
import MagicSquaresMeeting from 'assets/telegram/34-1.jpg';
import MedicalDataTalk from 'assets/telegram/27-1.jpg';
import MedicalDataMeeting from 'assets/telegram/28-2.jpg';
import SpeechRecognitionMeeting from 'assets/telegram/28-1.jpg';
import FirstDataDinner from 'assets/telegram/16-1.jpg';

import { ContentSectionContainer } from 'components/layout/contentSectionContainer/ContentSectionContainer';

import { Section } from 'routes/section';

const galleryImages = [
  { src: Meeting202602, alt: 'Встреча Tomsk Data Science в феврале 2026 года' },
  { src: Meeting202503, alt: 'Встреча Tomsk Data Science в марте 2025 года' },
  { src: Meeting202412, alt: 'Доклад об итогах развития LLM в 2024 году' },
  { src: Meeting202409, alt: 'Участники августовской встречи Tomsk Data Science' },
  { src: Meeting20240727, alt: 'Участники июльской встречи Tomsk Data Science' },
  { src: Meeting202407A, alt: 'Дата-обед Tomsk Data Science в июле 2024 года' },
  { src: Meeting202407B, alt: 'Обсуждение на июльском дата-обеде' },
  { src: TinkoffMeetingA, alt: 'Совместная встреча Tomsk Data Science и Tinkoff' },
  { src: TinkoffMeetingB, alt: 'Разбор начала карьеры в IT вместе с Tinkoff' },
  { src: GeoDataScienceA, alt: 'Доклад о Geo Data Science' },
  { src: GeoDataScienceB, alt: 'Участники встречи о Geo Data Science' },
  { src: TextAnalyticsMeeting, alt: 'Разбор доклада о текстовой аналитике' },
  { src: DataFestBreakfast, alt: 'Дата-завтрак с обсуждением Data Fest Siberia' },
  { src: FirstMeetup, alt: 'Первый большой Tomsk Data Science Meetup' },
  { src: AutumnMeeting, alt: 'Осенняя встреча Tomsk Data Science в 2023 году' },
  { src: ReinforcementLearningMeeting, alt: 'Доклад об основах reinforcement learning' },
  { src: MagicSquaresMeeting, alt: 'Доклад о магических квадратах' },
  { src: MedicalDataTalk, alt: 'Доклад о медицинских данных и обработке сигналов' },
  { src: MedicalDataMeeting, alt: 'Участники встречи о медицинских данных' },
  { src: SpeechRecognitionMeeting, alt: 'Выступление на одной из первых встреч сообщества' },
  { src: FirstDataDinner, alt: 'Первый дата-ужин сообщества' },
];

const GallerySection: React.FC = () => (
  <ContentSectionContainer id={Section.GALLERY} type="middle">
    <h4>Галерея</h4>
    <Swiper
      slidesPerView="auto"
      spaceBetween={30}
      speed={0}
      pagination={{ clickable: true }}
      modules={[Pagination]}
      className="mySwiper"
    >
      {galleryImages.map((image) => (
        <SwiperSlide key={image.src} style={{ width: 'fit-content' }}>
          <div><GalleryImage src={image.src} alt={image.alt} loading="lazy" /></div>
        </SwiperSlide>
      ))}
    </Swiper>
  </ContentSectionContainer>
);

export default GallerySection;

// END_MODULE pages_main_sections_gallery_gallery_tsx
